var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 10.5V9.5C7.99805 8.96957 7.78733 8.46086 7.41226 8.08579C7.03719 7.71071 6.52848 7.5 5.99805 7.5H2.99805C2.46761 7.5 1.95891 7.71071 1.58383 8.08579C1.20876 8.46086 0.998047 8.96957 0.998047 9.5V10.5",
    stroke: "#616E85",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49805 5.5C5.60262 5.5 6.49805 4.60457 6.49805 3.5C6.49805 2.39543 5.60262 1.5 4.49805 1.5C3.39348 1.5 2.49805 2.39543 2.49805 3.5C2.49805 4.60457 3.39348 5.5 4.49805 5.5Z",
    stroke: "#616E85",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 5.5L9.00195 6.5L11.002 4.5",
    stroke: "#616E85",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvited);
export default __webpack_public_path__ + "static/media/Invited.08dfdc8a4ea5e8035c2347b3bf52d2d2.svg";
export { ForwardRef as ReactComponent };